import { render, staticRenderFns } from "./FormDetailUiComponent.vue?vue&type=template&id=19719949&"
import script from "./FormDetailUiComponent.vue?vue&type=script&lang=js&"
export * from "./FormDetailUiComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailUiComponent.vue?vue&type=style&index=0&id=19719949&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports